import {
  addResultListener,
  BrillenSdkButtons,
  MeasurementResult,
  prepare,
} from '@modules/brillen-sdk'
import useSdkModuleStorage from '@modules/brillen-sdk/src/useSdkModuleStorage'
import { useOrderState } from '@order/hooks/useOrderState'
import { debugFrames } from '@order/utils/getDebugLog'
import { useCallback, useEffect } from 'react'
import MeasurementUtils from 'utils/MeasurementUtils'

const useSdkMeasureListener = (
  onMeasure: (e: MeasurementResult) => void,
  limitType?: 'pd' | 'sh'
) => {
  useEffect(() => {
    const subscription = addResultListener((e) => {
      const { frame, type } = useSdkModuleStorage.getState()
      debugFrames.log('useSaveCustomerFrame invoked', e, frame, type)

      if (limitType && type !== limitType) {
        debugFrames.log('useSaveCustomerFrame return', e.button, frame, type)
        return
      }

      if (e.button === BrillenSdkButtons.close) {
        return
      }

      if (e.button !== BrillenSdkButtons.save) {
        return
      }

      onMeasure(e)
    })
    prepare()

    return () => subscription?.remove()
  }, [])
}

export const useSdkMeasureListenerPd = () => {
  const updatePd = useOrderState((s) => s.updatePd)

  const onMeasure = useCallback(
    (e: MeasurementResult) => {
      const { left, right } = MeasurementUtils.parse.pd.result(e)
      updatePd(
        {
          l_pd: left,
          r_pd: right,
        },
        'measurement'
      )
    },
    [updatePd]
  )

  return useSdkMeasureListener(onMeasure, 'pd')
}

export default useSdkMeasureListener
